import { Container, Typography } from "@mui/material";

const MaintenanceContainer = () => (
  <Container
    maxWidth="lg"
    sx={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      textAlign: "center",
    }}
  >
    <Typography
      sx={{
        fontSize: {
          lg: "3em",
          md: "2em",
        },
      }}
      gutterBottom
    >
      🚧 Gather is Under Maintenance 🚧
    </Typography>
    <Typography
      sx={{
        fontSize: {
          lg: "2em",
          md: "1em",
        },
      }}
    >
      Our engineers are currently negotiating with the servers.
      <br />
      Coffee is involved. Please check back soon.
    </Typography>
  </Container>
);

export default MaintenanceContainer;
